import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_KEYSTONE_TEAM_RANKINGS,
  SHOW_KEYSTONE_LOADING_SPINNER,
  CLEAR_KEYSTONE_TEAMS,
  SET_KEYSTONE_RANKINGS_ERROR,
  REFRESH_KEYSTONE_RANKINGS
} from '../actions/keystoneActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';
import _ from 'lodash';

const roleSorts: any = {
  tank: 1,
  healer: 2,
  dps: 3
};

function ordinalForRole(role: string): number {
  if (!role) {
    return 999;
  }
  const roleCheck = role.toLowerCase();
  return roleSorts[roleCheck] || 999;
}

function sortRoster(a: any, b: any) {
  const aRoleOrder = ordinalForRole(a.role);
  const bRoleOrder = ordinalForRole(b.role);
  if (aRoleOrder === bRoleOrder) {
    if (b.character.name === a.character.name) {
      return 0;
    } else if (a.character.name < b.character.name) {
      return -1;
    } else {
      return 1;
    }
  } else {
    return aRoleOrder - bRoleOrder;
  }
}

function sortRuns(a: any, b: any) {
  if (a.mythicLevel === b.mythicLevel) {
    return a.zoneId - b.zoneId;
  } else {
    return b.mythicLevel - a.mythicLevel;
  }
}

export default function keystoneCharacterRankings(
  state: Partial<TCharacterDetailsClientState> = {},
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case SET_KEYSTONE_TEAM_RANKINGS: {
      action.payload.rankedTeams.forEach((group: any) => {
        group.members.sort(sortRoster);
        if (group.runs) {
          group.runs.sort(sortRuns);
        }
      });

      return {
        ...state,
        ...action.payload,
        isRefreshing: false,
        isLoaded: true
      };
    }
    case SHOW_KEYSTONE_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload ? action.payload.show : action.payload
      };
    }
    case SET_KEYSTONE_RANKINGS_ERROR: {
      return {
        ...state,
        isError: true,
        isRefreshing: false,
        error: action.payload.error
      };
    }
    case REFRESH_KEYSTONE_RANKINGS: {
      return {
        ...state,
        isRefreshing: true
      };
    }
    case CLEAR_KEYSTONE_TEAMS: {
      return {};
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default: {
      return state;
    }
  }
}
